import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";

// Tabs that has the same HTML as the CORE's tabs
// to use JS attached to it in Core.
export const TabsMenu = ({ className, menus }) => {
    const ref = useRef(null)
	const { t, i18n } = useTranslation(['general']);

	let menuItems = menus;
    menuItems.sort(function(x,y){ return x.label == 'Popular' ? -1 : y.label == 'Popular' ? 1 : 0; });

    useEffect(() => {
        // Init the tabs using mzTabs.init() from Core.
        if (window.mzTabs && typeof window.mzTabs.init === 'function') {
            if (ref.current) {
                window.mzTabs.init([ref.current]);
            }
        }
    }, [])

	for (let v of menuItems){
		if(v.label === 'Popular') v.label=t('popular');
		if(v.label === 'All') v.label=t('all');
	}

    return (
        <div className={`mz-tabs ${className}`} ref={ref}>
            <div className="mz-tabs-menu">
                <div className="mz-tabs-menu-container">
                    <div className="mz-tabs-menu-inner">
                        {
                            menuItems.map((menu) => (
                                <a
                                    key={menu.id}
                                    className={`mz-tabs-tab interactive ${menu['isactive'] ==='true' ? 'active' : ''}`}
                                    {...menu}
                                >
                                    {menu.label}
                                </a>
                            ))
                        }
                    </div>
                </div>
                <div className="mz-tabs-menu--left"><i className="mz-svg mz-svg--grey mz-svg-chevroncarousel mz-svg--rotate180"></i></div>
                <div className="mz-tabs-menu--right"><i className="mz-svg mz-svg--grey mz-svg-chevroncarousel"></i></div>
            </div>
        </div>
    );
}

TabsMenu.propTypes = {
    menus: PropTypes.array.isRequired,
    className: PropTypes.string,
}